import { render } from "./StandardHeaderChatButton.vue?vue&type=template&id=2a568a86"
import script from "./StandardHeaderChatButton.vue?vue&type=script&lang=js"
export * from "./StandardHeaderChatButton.vue?vue&type=script&lang=js"

import "./StandardHeaderChatButton.vue?vue&type=style&index=0&id=2a568a86&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__